import { useNavVerticalContext } from './NavVerticalContext'
import SimulatorModal from '../../../components/simulator-modal'
import NotifyTransactionModal from '../header/NotifyTransactionModal'

// ----------------------------------------------------------------------

export default function NavModals() {
  const { simulatorModal, notifyTransactionModal } = useNavVerticalContext()

  return (
    <>
      <SimulatorModal ref={simulatorModal} />
      <NotifyTransactionModal ref={notifyTransactionModal} />
    </>
  )
}
